import { useState, useEffect, useContext } from "react";
import {    Grid, Stack, Box, Tooltip,
            GTIWebDataGrid, GTIWebButton
} from "@gti-controls-v2/web-core";
import { GTIWebModal } from "../../../components/modal";
import { titleIcons } from "../../../common/constants/TitleIcons";
import { SettingsContext } from "../../../providers/settings";
import useUnificar from "../../../hooks/useUnificar";
import { useNavigate } from "react-router-dom";
import { paths } from "../../../common/constants/Rutas";

const modalOptions = {
    info: {
        title: "Selecciona una empresa",
        description: "Para poder unificar los datos correctamente, necesitamos saber a qué empresa pertenece el empleado. Por favor, selecciona una empresa antes de continuar.",
        icon: titleIcons.info
    },
    error: {
        title: "No hay CURPs para unificar",
        description: "El empleado seleccionado no tiene otra CURP registrada para realizar la unificación. Por favor, verifica que la selección sea correcta.",
        icon: titleIcons.error
    }
};

const Companies = ({ CURP, TicketID, data }) => {
    const navigate = useNavigate();
    const { isLoading, handleLoading } = useContext(SettingsContext);
    const { getCURPUnificar } = useUnificar();
    const [companies, setCompanies] = useState([]);
    const [open, setOpen] = useState();
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [modalConfig, setModalConfig] = useState(modalOptions.info);

    useEffect(() => {
        setCompanies(data);
        // eslint-disable-next-line
    }, [])

    const companiesGridColumns = [
        { field: "EmpNumero", headerName: "Número de Empleado", width: 200 },
        { field: "EmpresaRFC", headerName: "RFC", width: 200 },
        { field: "EmpresaNombre", headerName: "Nombre", width: 400 },
    ];

    const columnsPanel = [
        [{
            field: "EmpInicial",
            label: "Fecha Ingreso"
        },
        {
            field: "EmpFinal",
            label: "Fecha Baja"
        }],
        [{
            field: "NominaPuesto",
            label: "Puesto"
        }]
    ];

    const detailPanelContentProp = (data, schema) => (
        <Grid container >
            {
                schema && schema.map((column, key_column) => {
                    return (
                        <Grid item xs={6} key={key_column}>
                            {
                                column.map((row, key_row) => {
                                    return (
                                        <Stack xs={12} key={key_row} padding={4} spacing={2} direction={"row"} alignItems="center">
                                            <Box sx={{ fontWeight: 500 }}>
                                                {`${row.label}: `}
                                            </Box>
                                            <Box>
                                                {`${data[row.field]}`}
                                            </Box>
                                        </Stack>
                                    );
                                })
                            }
                        </Grid>
                    );
                })
            }
        </Grid>
    );

    const unifyMethod = async () => {
        handleLoading(true);

        if (selectedCompany === null) {
            setModalConfig(modalOptions.info);
            setOpen(true);
        } else {
            const result = await getCURPUnificar(selectedCompany.EmpNumero, selectedCompany.EmpresaID);

            if (result.data !== null) {
                navigate(paths.UnificarCURPS, { state: { ...result.data, TicketID: TicketID, EmpresaID: selectedCompany.EmpresaID } });
            } else {
                setModalConfig(modalOptions.error);
                setOpen(true);
            }
        }

        handleLoading(false);
    };

    const onCloseModal = () => {
        setOpen(!open);
    };

    return (
        <Grid marginTop={4}>
            <Grid container direction="column">

                <GTIWebModal 
                    open={open}
                    title={modalConfig.title}
                    description={modalConfig.description}
                    hideCancelButton
                    onClose={onCloseModal}
                    icon={modalConfig.icon}
                />

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Tooltip title={selectedCompany === null ? "Selecciona una Empresa del Grid" : ""} arrow>
                        <span>
                            <GTIWebButton 
                                text="Unificar CURP(s)" 
                                disabled={isLoading || selectedCompany === null}
                                iconPosition="end"
                                onClick={unifyMethod}
                            />
                        </span>
                    </Tooltip>
                </Box>

                <GTIWebDataGrid 
                    pageSize={20}
                    rows={companies}
                    columns={companiesGridColumns}
                    getRowId={(r) => r.EmpresaID}
                    disableColumnMenu
					disableColumnSelector
                    detailPanelColumnsSchema={columnsPanel}
                    detailPanelContent={detailPanelContentProp}
                    onSelectionChange={(e) => setSelectedCompany(e)}
                    disableClearSelectionOnFilter
                />
            </Grid>
        </Grid>
    );
};

export default Companies;